import apiClient from "./apiService";

export const setAccessToken = (token: string): void => {
  sessionStorage.setItem("accessToken", token);
};

export const getAccessToken = (): string | null => {
  return sessionStorage.getItem("accessToken");
};

export const removeAccessToken = (): void => {
  sessionStorage.removeItem("accessToken");
};

export const setUserStorage = (user: object): void => sessionStorage.setItem("user", JSON.stringify(user));

export const getUserStorage = (): string | null => sessionStorage.getItem("user");

export const removeUserStorage = (): void => sessionStorage.removeItem("user");

export const updatePassword = (currentPassword: string, newPassword: string) =>
  apiClient.post('/auth/change-password', { currentPassword, newPassword });

export const deleteAccount = (password: string) =>
  apiClient.delete('/auth/delete-account', { data: { password } });

export const restoreAccount = (password: string) =>
  apiClient.post('/auth/restore-account', { password });
